export function mapCfEntityToCfDiscountBanner(cfEntity = {}) {
    const { fields } = cfEntity;

    const {
        versionA,
        versionACopyableText,
        versionB,
        versionBCopyableText,
        versionC,
        versionCCopyableText,
        uniqueBrandContent,
        uniqueStoreContent,
    } = fields || {};

    return {
        versionA: {
            text: versionA,
            copyableText: versionACopyableText,
        },
        versionB: {
            text: versionB,
            copyableText: versionBCopyableText,
        },
        versionC: {
            text: versionC,
            copyableText: versionCCopyableText,
        },
        uniqueBrandContent,
        uniqueStoreContent,
    };
}
